interface ApiConfig {
    apiUrl: string;
    endpoints: {
        businessAreas: string;
        rules: string;
        toggle: string;
        pldReports: string;
        pldReportsCheck: string;
    };
    authentication: {
        type: string;
        headerName: string;
        apiKey: string;
    };
}

class ConfigService {
    private config: ApiConfig | null = null;

    getConfig(): ApiConfig {
        if (this.config) {
            return this.config;
        }

        // Configuração baseada em variáveis de ambiente seguindo padrão do backoffice
        const baseApiUrl = process.env.REACT_APP_RECOMMENDATION_ENGINE_API_URL || 
                          'https://7lzi1jin22.execute-api.us-east-1.amazonaws.com/v1';
        
        const apiKey = process.env.REACT_APP_API_KEY || 
                      'qlcZJhVGBa9msKI7V1kJL2M8fXvYwNpT4rEuIoHg';

        this.config = {
            apiUrl: baseApiUrl,
            endpoints: {
                businessAreas: '/recommendations/business-areas',
                rules: '/rules',
                toggle: '/rules/{id}/toggle',
                pldReports: '/pld-reports',
                pldReportsCheck: '/pld-reports/check'
            },
            authentication: {
                type: 'API_KEY',
                headerName: 'x-api-key',
                apiKey: apiKey
            }
        };

        return this.config;
    }

    // Método para limpar cache (útil para testes)
    clearCache(): void {
        this.config = null;
    }
}

export const configService = new ConfigService();
export type { ApiConfig };
